module.exports = __webpack_public_path__ + "dist/media/logo--pt.c4dbc02a.svg";